import { render } from "./FpuiInputTimePeriod.vue?vue&type=template&id=18a61278&lang=pug"
import script from "./FpuiInputTimePeriod.vue?vue&type=script&lang=js"
export * from "./FpuiInputTimePeriod.vue?vue&type=script&lang=js"

import "./FpuiInputTimePeriod.vue?vue&type=style&index=0&id=18a61278&lang=less"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__